import { SocialPerson } from '@/models/Person';
import { analyticsService, FlowEvents } from '@/services/AnalyticsService';
import { getDisplayName } from '@/services/UtilService';
import { ApplicationState } from '@/store';
import { clearFollowers, clearFollowing, decreaseFollowing, increaseFollowing } from '@/store/followers/action';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PersonImage from '../PersonImage';
import './style.scss';

interface Props {
    follower: SocialPerson;
    closeModal: CallableFunction;
    showFollowButton: boolean;
    isLoggedUserProfile: boolean;
    updateActions: (person: SocialPerson) => void;
}
const FollowerCard = (props: Props) => {
    const { follower, closeModal, showFollowButton, isLoggedUserProfile, updateActions } = props;

    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    const [following, setFollowing] = useState<boolean>(follower.followedByMe);
    const dispatch = useDispatch();
    const history = useHistory();

    const navigateToProfile = (externalPersonId: number | undefined) => {
        analyticsService.logEvent(
            isLoggedUserProfile ? FlowEvents.ACCESS_PROFILE_LIST_FOLLOWERS_MY_PROFILE : FlowEvents.ACCESS_PROFILE_LIST_FOLLOWERS_PUB_PROFILE,
        );
        history.push(`/profile/${externalPersonId}/info`);
        closeModal();
        dispatch(clearFollowers());
        dispatch(clearFollowing());
    };

    const follow = () => {
        setFollowing(true);
        analyticsService.logEvent(
            isLoggedUserProfile ? FlowEvents.FOLLOW_LIST_FOLLOWERS_MY_PROFILE : FlowEvents.FOLLOW_LIST_PROFILE_FOLLOWERS_PUB_PROFILE,
        );
        dispatch(increaseFollowing(isLoggedUserProfile));
        updateActions(follower);
    };

    const unFollow = () => {
        setFollowing(false);
        dispatch(decreaseFollowing(isLoggedUserProfile));
        updateActions(follower);
    };

    return (
        <div className="follower-card-container">
            <PersonImage size={48} src={follower.thumbnail} />
            <div className="follower-info">
                <span className="follower-name" onClick={() => navigateToProfile(follower.id)}>
                    {getDisplayName(follower)}
                </span>
                {follower.position && <span className="follower-role">{follower.position}</span>}
            </div>
            {!showFollowButton && (
                <div className="follower-action">
                    <button className={`btn btn-primary ${following ? 'btn-unfollow' : ''}`} onClick={() => (following ? unFollow() : follow())}>
                        {following ? strings.FOLLOWING : strings.FOLLOW}
                    </button>
                </div>
            )}
        </div>
    );
};

export default FollowerCard;
